import React, {
  useContext,
  useEffect,
  useState,
  useCallback,
  useRef
} from "react";
import Box from "@mui/material/Box";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { Accordion, AccordionSummary, AccordionDetails } from "@mui/material";
import { styled } from "@mui/material/styles";

import {
  Button,
  Divider,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TextField,
  Grid,
  Autocomplete,
  Typography
} from "@mui/material";

import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";

import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";

import UndoIcon from "@mui/icons-material/Undo";
import SaveIcon from "@mui/icons-material/Save";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import ContainerLoading from "../../../../components/Loading/ContainerLoading";

import ImageUploader from "./../KioskTheme/ImageUploader";

import { useTheme } from "@mui/material/styles";

import HttpContext from "../../../../contexts/HTTP/HttpContext";

let env = require("./../../../../env");

export default function AdsSettingPanel({
  initialAdsConfiguration,
  // open,
  hasChange,
  setHasChange,
  loading,
  // handleClose,
  handleSaveEditChanges
}) {
  // Stabilize the setHasChange function using useRef
  const setHasChangeRef = useRef();
  setHasChangeRef.current = setHasChange;

  const stableSetHasChange = useCallback(value => {
    setHasChangeRef.current(value);
  }, []);

  // Stabilize other callback props too
  const handleSaveRef = useRef();
  handleSaveRef.current = handleSaveEditChanges;

  // const stableHandleSave = useCallback(async payload => {
  //   await handleSaveRef.current(payload);
  // }, []);

  // Add this debug block RIGHT AT THE TOP
  console.log("[AdsSettingsPanel] COMPONENT RENDER");

  const theme = useTheme();
  const { get, post } = useContext(HttpContext);

  // ... your existing state declarations ...
  const [currentAdsConfig, setCurrentAdsConfig] = useState({});

  // Track when theme changes (AFTER currentTheme is declared)
  const prevTheme = useRef();
  useEffect(() => {
    if (prevTheme.current !== currentAdsConfig) {
      console.log("[AdsSettingsPanel] currentAdsConfig changed", {
        prev: prevTheme.current,
        current: currentAdsConfig
      });
      prevTheme.current = currentAdsConfig;
    }
  }, [currentAdsConfig]);

  // Rest of your component...

  const [primaryColorDialogOpen, setPrimaryColorDialogOpen] = useState(false);
  const [secondaryColorDialogOpen, setSecondaryColorDialogOpen] = useState(
    false
  );
  const [trinaryColorrDialogOpen, setTrinaryColorDialogOpen] = useState(false);

  const [currentLanguageTab, setCurrentLanguageTab] = useState("Fr");

  const [expandedSections, setExpandedSections] = useState(
    new Set([
      "color-other",
      "color-main-screen",
      "color-qr-code",
      "color-telephone",
      "color-inner",
      "color-header-footer",
      "main-screen",
      "quickstart-qr",
      "customer-telephone",
      "wizard",
      "footer",
      "bagsonly",
      "select-bags",
      "select-labels",
      "approval-screen",
      "thank-you"
    ])
  );

  // const [currentTheme, setCurrentTheme] = useState({});

  //Reloading theme
  useEffect(() => {
    if (initialAdsConfiguration) {
      setCurrentAdsConfig({ ...initialAdsConfiguration });
    }
  }, [initialAdsConfiguration]);

  const saveChanges = async () => {
    const payload = currentAdsConfig;
    await handleSaveEditChanges(payload);
  };

  const revertChanges = async () => {
    if (initialAdsConfiguration) {
      setCurrentAdsConfig({ ...initialAdsConfiguration });
    }
  };

  const handleChangeLanguageTab = (event, newValue) => {
    setCurrentLanguageTab(newValue);
  };

  const handleUpdateChanges = useCallback(async newchanges => {
    setCurrentAdsConfig(prevTheme => {
      const updatedTheme = { ...prevTheme, ...newchanges };
      console.log(
        "[handleUpdateChanges] DEBUG updatedTheme, newchanges",
        updatedTheme,
        newchanges
      );
      return updatedTheme;
    });
    setHasChangeRef.current(true); // Use ref directly instead of stableSetHasChange
  }, []); // Empty dependencies - now truly stable

  const handleTranslationUpdate = useCallback(
    (translationValue, language, newValue) => {
      setCurrentAdsConfig(prevTheme => ({
        ...prevTheme,
        translations: {
          ...prevTheme.translations,
          [translationValue]: {
            ...prevTheme.translations?.[translationValue],
            [language]: newValue
          }
        }
      }));
      setHasChangeRef.current(true); // Use the ref directly instead of stableSetHasChange
    },
    [] // Now this is truly stable
  );

  const handleAccordionChange = sectionId => (event, isExpanded) => {
    console.log("[handleAccordionChange] event, isExpanded", event, isExpanded);
    setExpandedSections(prev => {
      const newSet = new Set(prev);
      if (isExpanded) {
        console.log("[handleAccordionChange] add sectionId", sectionId);
        newSet.add(sectionId);
      } else {
        newSet.delete(sectionId);
        console.log("[handleAccordionChange] delete sectionId", sectionId);
      }
      return newSet;
    });
  };

  return (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "flex-end",
          alignItems: "center",
          marginTop: theme.spacing(2)
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            gap: theme.spacing(1)
          }}
        >
          {hasChange ? (
            <div
              style={{
                marginTop: "6px",
                fontStyle: "italic",
                color: "darkorange"
              }}
            >
              Changes pending
            </div>
          ) : (
            <></>
          )}
          <Button
            variant="outline"
            onClick={() => revertChanges()}
            disabled={loading}
          >
            <UndoIcon style={{ marginRight: theme.spacing(1) }} />
            Revert
          </Button>
          <Button
            variant="contained"
            onClick={() => saveChanges()}
            disabled={loading}
          >
            <SaveIcon style={{ marginRight: theme.spacing(1) }} />
            Save
          </Button>
        </div>
      </div>

      <Divider
        style={{ marginBottom: theme.spacing(2), marginTop: theme.spacing(2) }}
      />
      <ContainerLoading show={loading} />
      <TableContainer>
        <Table
          style={{
            marginTop: theme.spacing(2),
            display: loading ? "none" : null
          }}
        >
          <TableHead></TableHead>

          <center>
            {/* <Grid container width="30vw" spacing={2}> */}
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Box
                  sx={{
                    borderBottom: "1px solid",
                    borderColor: "divider",
                    pb: 1,
                    mb: 1
                  }}
                >
                  <Typography
                    variant="h6"
                    color="primary"
                    sx={{ fontWeight: 600 }}
                  >
                    Ad 1
                  </Typography>
                </Box>
              </Grid>

              <Grid item xs={6} style={{ alignContent: "center" }}>
                Ad Group Name
              </Grid>
              <Grid item xs={6} style={{ alignContent: "center" }}>
                Main Ads
              </Grid>

              <Grid item xs={6} style={{ alignContent: "center" }}>
                Ad 1
              </Grid>
              <Grid item xs={6} style={{ alignContent: "center" }}>
                <ImageUploader
                  previewImgPath={
                    env.REACT_APP_API_ENDPOINT + "/kiosk/getImage/Ad"
                  }
                  //expectedWidth={1693}
                  // expectedHeight={227}
                  post={post}
                  ImageType={"Ad1"}
                  setPathFunc={filename => {
                    handleUpdateChanges({ headerLogoPath: filename });
                  }}
                />
              </Grid>
            </Grid>
          </center>
        </Table>
      </TableContainer>
    </>
  );
}
